module.exports = __webpack_public_path__ + "static/media/iconpro-cal.490def51.png";